import { css } from 'styled-components';
export const position = css `
  ${({ $position, $top, $bottom, $left, $right }) => `
    ${$position ? `position: ${$position};` : ''}
    ${$top ? `top: ${$top};` : ''}
    ${$bottom ? `bottom: ${$bottom};` : ''}
    ${$left ? `left: ${$left};` : ''}
    ${$right ? `right: ${$right};` : ''}
  `}
`;
export const positionKeys = [
    'position',
    'top',
    'bottom',
    'left',
    'right',
];
